<template>
	<transition name="modal">
		<div class="modal-mask">
			<div class="wrapper">
				<div class="container">
					<div class="body">
						<div class="body__title">
							<h1 class="body__title-text">{{ title }}</h1>
						</div>
						<div class="body__description">
							<p class="body__description-text">
								{{ subtitle }}
							</p>
						</div>
					</div>
					<div class="actions">
						<button id="action-btn" class="actions__btn outline" @click="handleDeleteModal()">
							Cancelar
						</button>
						<button
							id="action-btn"
							class="actions__btn"
							:class="loader ? 'disabled' : ''"
							@click="confirmDelete()"
						>
							<span v-if="!loader">Excluir</span>
							<SpinnerIcon :color="'white'" v-else />
						</button>
					</div>
				</div>
			</div>
		</div>
	</transition>
</template>

<script>
import CloseIcon from '@/components/shared/Icons/CloseIcon.vue';
import SpinnerIcon from '@/components/shared/Icons/SpinnerIcon.vue';

export default {
	name: 'DeleteModal',
	components: { CloseIcon, SpinnerIcon },
	props: {
		title: { required: true },
		subtitle: { required: true },
		loader: { required: true },
	},
	data: () => ({}),
	mounted() {},
	methods: {
		handleDeleteModal() {
			this.$emit('handleDeleteModal');
		},
		confirmDelete() {
			this.$emit('confirmDelete');
		},
	},
};
</script>

<style lang="scss" scoped>
@import 'DeleteModal.scss';
</style>
